import {create} from "zustand";

export const useProductStore = create((set, get) => ({
    // Данные по продукту
    productId: null,
    // Данные по продукту
    productDataCurrent: null,
    accordionItemControl: true,
    accordionItemControl1: false,
    accordionItemControl2: false,

    /**
     * Инициализация данных
     * @param product
     * @param product_data_current
     */
    initProduct: (product, product_data_current) => {
        if (get().productId === product.id) return;

        set({
            productId: product.id,
            productDataCurrent: product_data_current,
        });

        // const current =
        //     product.product_data.find(el => el.id === product.product_data_active_id) ||
        //     product.product_data[0];
        //
        // set({
        //     productId: product.id,
        //     productDataCurrent: current,
        // });
    },

    /**
     * Инициализация данных
     * @param product_data_current
     */
    changeProduct: (product_data_current) => {
        set({
            productDataCurrent: product_data_current,
        });

        // const current =
        //     product.product_data.find(el => el.id === product.product_data_active_id) ||
        //     product.product_data[0];
        //
        // set({
        //     productDataCurrent: current,
        // });
    },

    /**
     * Очищение данных
     */
    deleteProduct: () => {
        set({
            productId: null,
            productDataCurrent: null,
        });
    },

    changeAccordionProduct: (accordion) => set({
        accordionItemControl: false,
        accordionItemControl1: false,
        accordionItemControl2: false,
        [accordion]: true,
    }),

    /**
     * Переключаем нужный размер
     * @param el - выбранный елемент
     */
    switchSize: (el = {}) => set({productDataCurrent: el}),
}));
